<template>
  <div>
    <v-dialog width="500" @click:outside="closeModal" v-model="value">
      <v-card>
        <v-card-title class="">
          <span class="headline title_modal_user">{{
            $t("createSupplier")
          }}</span>
          <v-icon @click="closeModal" class="info_modal_close"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text>
          <validation-observer v-slot="{ handleSubmit }" ref="suppFormObs">
            <v-form @submit.prevent="handleSubmit(save)">
              <div class="d-flex align-center">
                <label class="px-2 primary--text font-weight-bold">{{
                  $t("name")
                }}</label>
                <div class="px-2 flex-grow-1">
                  <custom-input-text
                    class="user_input"
                    v-model="formData.name"
                    rules="required"
                  ></custom-input-text>
                </div>
              </div>
              <div class="pt-3 text-right">
                <v-btn @click="closeModal" class="mr-2" color="error">{{
                  $t("cancel")
                }}</v-btn>
                <v-btn type="submit" color="success">{{ $t("save") }}</v-btn>
              </div>
            </v-form>
          </validation-observer>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
  },
  data() {
    return {
      formData: {
        name: "",
      },
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.formData = { name: "" };
        const { suppFormObs } = this.$refs;
        if (suppFormObs) suppFormObs.reset();
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit("input", false);
    },
    async save() {
      this.showLoading();
      try {
        const data = await this.$store.dispatch(
          "createSupplier",
          this.formData
        );
        this.$emit("onSaved", data);
        this.setSuccess({ text: this.$t("successfullySaved") });
        this.closeModal();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
  },
};
</script>
